module.exports = __webpack_public_path__ + "static/media/maestro.e7089559.png";